import { apiUrl } from './api';

const proxiedPrefixes = ['/api', '/images', '/avatars', '/uploads', '/public'];

const isAbsoluteUrl = (value: string) => /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(value);

const normalizePath = (value: string) => (value.startsWith('/') ? value : `/${value}`);

const shouldProxy = (value: string) => {
  if (!value) return false;

  if (isAbsoluteUrl(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return false;
  }

  const normalized = normalizePath(value);
  return proxiedPrefixes.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`) || normalized.startsWith(`${prefix}?`));
};

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const originalFetch = window.fetch.bind(window);

  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string') {
      if (shouldProxy(input)) {
        const normalized = normalizePath(input);
        return originalFetch(apiUrl(normalized), init);
      }

      return originalFetch(input, init);
    }

    return originalFetch(input, init);
  }) as typeof window.fetch;
}
